var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('QuickTable',{ref:"table",attrs:{"request":"/api/services/app/SafetyBasic/GetNationalProjectAsync","columns":_vm.initData.columns,"exports":{url: '/api/File/ExportNationalProjectAsync', fileName: '所有国家项目和30万以上重大施工项目'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }